export default {
    EMAIL_VALIDATION: "^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z]{2,4})+$",
    NUMBER_ONLY: "^[0-9]*$",
};